gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.food-waste.prr-site-content')) {
// Create a ResizeObserver instance
const resizeObserver = new ResizeObserver(entries => {
  for (let entry of entries) {
    if (entry.target.classList.contains('split-section')) {
      ScrollTrigger.refresh();
    }
  }
});

    // Loop through each section with the class 'split-section'
    document.querySelectorAll('.split-section').forEach(section => {
      const firstImage = section.querySelector('.first-image');
      const secondImage = section.querySelector('.second-image');

  const animation = {
    y: 0,
    delay: 0.3,
    duration: 0.8,
    scrollTrigger: {
        trigger: section,
            start: 'top 270px',
        toggleActions: 'play none none reverse',
    },
  };

      if (firstImage && secondImage) {
        // Animation for the first image
        gsap.to(firstImage, animation);
        // Animation for the second image
        gsap.to(secondImage, animation);
      }

  // Observe changes to the size of each section. Prevent bug when animation starts earlier because some previous
  // sections' height changed, but the point where the animation starts remained the same.
  resizeObserver.observe(section);
});
  }
})